export const useRegionList = async () => {
  return useFetchSafely(() => `regions`);
};

export const useClinicSearchDetail = async () => {
  return useFetchSafelyCached("pages/clinics");
};

export const usePopularCitiesList = async () => {
  return useFetchSafelyCached("popular-cities");
};

export const useClinicListsByCity = async (mapData) => {
  return useFetchSafelyCached("clinics", {
    params: mapData,
  });
};

export const useCityDetailPage = async (slug) => {
  return useFetchSafely(() => `city/${slug}`);
};

export const useFetchClinicDetailBySlug = async (slug) => {
  return useFetchSafely(() => `clinics/${slug}`);
};

export const useBlockReview = async (slug) => {
  return useFetchSafelyCached("customer-reviews/reviews", {
    params: { block: slug },
  });
};

export const useClinicSiteMarkers = async () => {
  //return useFetchSafelyCached("clinic-site-markers");
  return useFetchSafely(() => `clinic-site-markers`);
};
